import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class RoleStatusConverter implements JsonCustomConvert<Role>{
	serialize() { }
	deserialize(data: any): Role {
		switch (data) {
			case 'SUPER_ADMIN':
				{
					return Role.SUPER_ADMIN;
				}
			case 'ADMIN':
				{
					return Role.ADMIN;
				}
			case 'USER':
				{
					return Role.USER;
				}
			case 'VIEWER':
				{
					return Role.VIEWER;
				}
			default:
				{
					return Role.USER;
				}
		}
	}
}


export enum Role {
	SUPER_ADMIN = 'SUPER_ADMIN',
	ADMIN = 'ADMIN',
	USER = 'USER',
	VIEWER = 'VIEWER'
}
